/* eslint-disable linebreak-style */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import styled from '@react-pdf/styled-components';
import { t } from '../../../../i18n';


// Create styles
const styles = StyleSheet.create({
  section: {
    marginLeft: 25, 
    marginTop:5,
    marginBottom:5
  },
  row: {
    display: 'flex',
    flexDirection:'row',
    marginTop:0,
    marginBottom:0,
    marginLeft: 5,
    marginRight: 5,
  },
});


const Cell = styled.Text`
  padding:5px;
  font-size: 8px;
  margin-left:-1px;
  margin-top:-1px;
  border:1px solid ;
  width:10%;
  text-align: center;
`;
const CellMedii = styled.Text`
  padding:5px;
  font-size: 8px;
  margin-left:-1px;
  margin-top:-1px;
  border:1px solid ;
  width:7%;
  text-align: center;
`;
const CellMici = styled.Text`
  padding:5px;
  font-size: 8px;
  margin-left:-1px;
  margin-top:-1px;
  border:1px solid ;
  width:5%;
  text-align: center;
`;
const CellTotal = styled.Text`
  padding:15px;
  font-size: 10px;
  margin-left:-1px;
  margin-top:-1px;
  text-align: right;
  width:100%;
`;

// Create Document Component
const ContentJV = (props) => (
  <View style={styles.section}>
    <View style={styles.row}>
      <CellMici fixed>{t('pdf.content.nrCrt')}</CellMici>
      <CellMedii fixed>{t('pdf.content.tip')}</CellMedii>
      <CellMici fixed>{t('pdf.content.lungime')}</CellMici>
      <CellMici fixed>{t('pdf.content.inaltime')}</CellMici>
      <CellMici fixed>{t('pdf.content.tipDesc')}</CellMici>
      <CellMedii fixed>{t('pdf.content.material')}</CellMedii>
      <CellMici fixed>{t('pdf.content.cod1')}</CellMici>
      <CellMici fixed>{t('pdf.content.cod2')}</CellMici>
      <Cell fixed>{t('pdf.content.combCoduri')}</Cell>
      <CellMici fixed>{t('pdf.content.lungimeSnurShort')}</CellMici>
      <Cell fixed>{t('pdf.content.tipConsole')}</Cell>
      <CellMici fixed>{t('pdf.content.nrConsole')}</CellMici>
      <Cell fixed>{t('pdf.content.optional')}</Cell>
      <CellMedii fixed>{t('pdf.content.observatii')}</CellMedii>
      <CellMici fixed>{t('pdf.content.cant')}</CellMici>
      <CellMici fixed>{t('pdf.content.pretLei')}</CellMici>
    </View>
    {props.currentOrder.comandarepers?
      props.currentOrder.comandarepers.sort((a, b) => {
        return new Date(a.actionare) - new Date(b.actionare)}).map(item=>
        <View style={styles.row} key={item.id}>
          <CellMici fixed>{item.nrCrt}</CellMici>
          <CellMedii fixed>{item.denumireSubProdus}</CellMedii>
          <CellMici fixed>{item.lungime}</CellMici>
          <CellMici fixed>{item.inaltime}</CellMici>
          <CellMici fixed>{item.deschidere}</CellMici>
          <CellMedii fixed>{item.denumireMaterial}</CellMedii>
          <CellMici fixed>{item.denumireCuloareLamela}</CellMici> 
          <CellMici fixed>{item.denumireCuloareCaseta}</CellMici>
          <Cell fixed>{item.codCuloare}</Cell>
          <CellMici fixed>{item.lungimeSnur}</CellMici>
          <Cell fixed>{item.denumireOptional1}</Cell>
          <CellMici fixed>{item.console}</CellMici>
          <Cell fixed>{item.denumireOptional2}</Cell>
          <CellMedii fixed>{item.observatii}</CellMedii>
          <CellMici fixed>{item.buc}</CellMici>
          <CellMici fixed>{item.pretClientFinal}</CellMici>
        </View>
      )
      
      :<Text>{t('pdf.common.noRows')}</Text>
    }
    <View style={styles.row}>
      <CellTotal fixed>{t('pdf.common.total', { value: props.currentOrder.valoareClientFinal, currency: 'lei' })}</CellTotal>
    </View>
  </View>
);



export default ContentJV